import { ROUTES } from '@analyzer/utils/router/paths'
import { useAuthStore } from '@core/stores/auth-store'
import { createFileRoute, Outlet, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/(auth)')({
  beforeLoad: () => {
    if (useAuthStore.getState().isLogged()) throw redirect({ to: ROUTES.root })
  },
  component: Outlet,
})
